import React from 'react'
import './Sidebar.scss'
import Logo from '../img/pl.png'
import {Link, NavLink} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import CodeIcon from '@mui/icons-material/Code';
import SchoolIcon from '@mui/icons-material/School';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import GitHubIcon from "@mui/icons-material/GitHub";
// import GitHubIcon from '@mui/icons-material/GitHub';
import { AiFillLinkedin } from "react-icons/ai";
function Sidebar() {
  return (
    <div className='bg-black w-[100px] h-full left-0 absolute top-0 z-3 min-h-[600px] shadow-lg shadow-blue-300'>
        <Link className='logo block pt-2' to='/'>
            <img src={Logo} className='block h-auto w-50 ' />
            <h1 className=' p-1 text-xl text-gray-500'>Prarthna</h1>
        </Link>
        <nav className='flex flex-col text-center absolute top-[50%] w-full -mt-[120px]'>
            <NavLink exact="true" activeclassname="active" className="home-link" to='/'>
                <HomeIcon  className='m-2 text-[#4d4d4e] hover:text-[#8b3a85] hover:opacity-0 decoration-none '/>
                

            </NavLink>
            <NavLink exact="true" activeclassname="active" className="about-link" to='/about'>
               
                <PersonIcon  className='m-2 text-[#4d4d4e] hover:text-[#8b3a85] hover:opacity-0'/>

            </NavLink>
            <NavLink exact="true" activeclassname="active" className="education-link" to='/education'>
               
               <SchoolIcon className='m-2 text-[#4d4d4e] hover:text-[#8b3a85] hover:opacity-0'/>

           </NavLink>
           <NavLink exact="true" activeclassname="active" className="training-link" to='/training'>
               
               <WorkspacePremiumIcon className='m-2 text-[#4d4d4e] hover:text-[#8b3a85] hover:opacity-0'/>

           </NavLink>
            <NavLink exact="true" activeclassname="active" className="portfolio-link" to='/portfolio'>
               
               <CodeIcon className='m-2 text-[#4d4d4e] hover:text-[#8b3a85] hover:opacity-0'/>

           </NavLink>
           <NavLink exact="true" activeclassname="active" className="experience-link" to='/experience'>
               
               <WorkHistoryIcon className='m-2 text-[#4d4d4e] hover:text-[#8b3a85] hover:opacity-0'/>

           </NavLink>
            <NavLink exact="true" activeclassname="active" className="contact-link" to='/contact'>
               
               <ContactMailIcon className="m-2 text-[#4d4d4e] hover:text-[#8b3a85] hover:opacity-0 "/>

           </NavLink>
           
            
        </nav>
        <ul className=' absolute top-[90%] flex w-full  p-0 text-center m-0 '>
               <li>
                    <a rel="noreferrer"href='https://www.linkedin.com/in/prarthnaluthra/' target='_blank' className='p-[6px] block'><AiFillLinkedin  className=" linkedin m-2 text-[#4d4d4e] hover:text-[#02adc0] hover:cursor-pointer"/></a>
               </li>
                <li>
                    
                    <a rel="noreferrer" href="https://github.com/PrarthnaLuthra" target="_blank"><GitHubIcon className=" github m-2 text-[#4d4d4e] hover:text-[#02adc0] hover:cursor-pointer scale-[0.7]"/></a>

                </li>
               
                
            </ul>
        
    </div>
  )
}

export default Sidebar